export default {"src":"/_next/static/media/shower.b1176145.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};